import { render, staticRenderFns } from "./newnewspaper.vue?vue&type=template&id=d1f5ce9c&"
import script from "./newnewspaper.vue?vue&type=script&lang=js&"
export * from "./newnewspaper.vue?vue&type=script&lang=js&"
import style0 from "./newnewspaper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports